import React from 'react';
import { useFunnelsDropdown } from '@/modules/funnels/hooks/useFunnels';
import { Icon } from '@/shared/icons';

interface FunnelMultiSelectProps {
  selectedFunnelIds: string[];
  onSelectionChange: (funnelIds: string[]) => void;
}

const FunnelMultiSelect: React.FC<FunnelMultiSelectProps> = ({
  selectedFunnelIds,
  onSelectionChange,
}) => {
  const { data: funnels, isLoading } = useFunnelsDropdown();

  const toggleFunnel = (funnelId: string) => {
    const isSelected = selectedFunnelIds.includes(funnelId);
    if (isSelected) {
      onSelectionChange(selectedFunnelIds.filter((id) => id !== funnelId));
    } else {
      onSelectionChange([...selectedFunnelIds, funnelId]);
    }
  };

  if (isLoading) {
    return (
      <div
        className="px-4 py-3 rounded-lg border text-sm text-center"
        style={{
          backgroundColor: 'var(--theme-input-background)',
          borderColor: 'var(--theme-input-border)',
          color: 'var(--theme-muted-text)',
        }}
      >
        Carregando funis...
      </div>
    );
  }

  if (!funnels || funnels.length === 0) {
    return (
      <div
        className="px-4 py-3 rounded-lg border text-sm text-center"
        style={{
          backgroundColor: 'var(--theme-input-background)',
          borderColor: 'var(--theme-input-border)',
          color: 'var(--theme-muted-text)',
        }}
      >
        Nenhum funil cadastrado
      </div>
    );
  }

  return (
    <div
      className="rounded-lg border max-h-48 overflow-y-auto"
      style={{
        backgroundColor: 'var(--theme-input-background)',
        borderColor: 'var(--theme-input-border)',
      }}
    >
      {funnels.map((funnel: any) => {
        const isSelected = selectedFunnelIds.includes(funnel.id);
        return (
          <div
            key={funnel.id}
            className="flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors border-b last:border-b-0"
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={0}
            style={{
              borderColor: 'var(--theme-input-border)',
            }}
            onClick={() => toggleFunnel(funnel.id)}
            onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleFunnel(funnel.id); } }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--theme-button-ghost-hover)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <div
              className="w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0"
              style={{
                borderColor: isSelected ? 'var(--theme-primary)' : 'var(--theme-input-border)',
                backgroundColor: isSelected ? 'var(--theme-primary)' : 'transparent',
              }}
            >
              {isSelected && <Icon name="check" className="w-3 h-3 text-white" />}
            </div>
            <p
              className="text-sm font-medium"
              style={{ color: 'var(--theme-card-text)' }}
            >
              {funnel.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export type { FunnelMultiSelectProps };
export { FunnelMultiSelect };
